/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {FC} from 'react'
import {useSMSTemplateProvider} from '../context/SMSTemplateProvider'
import {ISMSTemplate} from '../core/_model'

type Props = {
  template: ISMSTemplate
}

const SMSTemplateAction: FC<Props> = ({template}) => {
  const {handleAction, deleteTemplate} = useSMSTemplateProvider()
  return (
    <>
      <button
        className='btn btn-secondary btn-sm'
        type='button'
        id='dropdownMenuButton'
        data-bs-toggle='dropdown'
        aria-haspopup='true'
        aria-expanded='false'
      >
        Action
        {/* <KTIcon iconName='down' className='fs-5' /> */}
      </button>
      <ul
        className='dropdown-menu menu menu-sub menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-125px py-4'
        aria-labelledby='dropdownMenuButton'
      >
        <div className='menu-item px-3'>
          <a
            className='menu-link px-3'
            data-bs-toggle='modal'
            data-bs-target='#kt_modal_1'
            onClick={() => handleAction(template)}
          >
            Edit
          </a>
        </div>
        <div className='menu-item px-3'>
          <a
            className='menu-link px-3'
            data-bs-toggle='modal'
            data-bs-target='#kt_modal_3'
            onClick={() => deleteTemplate(template.id)}
          >
            Delete
          </a>
        </div>
      </ul>
    </>
  )
}

export default SMSTemplateAction
